import { render, staticRenderFns } from "./WhatsAppSettingsForm.vue?vue&type=template&id=352eb0ef&scoped=true&"
import script from "./WhatsAppSettingsForm.vue?vue&type=script&lang=js&"
export * from "./WhatsAppSettingsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352eb0ef",
  null
  
)

export default component.exports